import { Link } from "react-router-dom";
import { motion } from "framer-motion";

const Reveal = ({ children, delay = 0, className = "" }) => (
  <motion.div
    initial={{ opacity: 0, y: 18 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.9, ease: "easeOut", delay }}
    className={className}
  >
    {children}
  </motion.div>
);

export default function Letter() {
  return (
    <div data-testid="letter-page">
      <section className="pt-32 lg:pt-44 pb-24">
        <div className="max-w-[820px] mx-auto px-6 sm:px-10">
          <Reveal>
            <div className="label-eyebrow text-center">A Letter from Anissa</div>
            <h1 className="serif mt-8 text-[36px] sm:text-[52px] leading-[1.1] tracking-tight text-center">
              For the woman <span className="italic">reading this quietly</span>.
            </h1>
          </Reveal>

          {/* Optional portrait placeholder — kept minimal, ready for a future photograph */}
          <Reveal delay={0.1}>
            <div className="mt-20 mb-16 mx-auto max-w-[340px] aspect-[4/5] border border-[#D5CDBF] bg-[#F2EFE5] flex items-center justify-center">
              <span className="serif italic text-[36px] text-[#C7BFAE]">A</span>
            </div>
          </Reveal>

          <Reveal delay={0.15}>
            <div className="space-y-8 text-[19px] sm:text-[20px] leading-[1.95] text-[#2E2B27] serif">
              <p>If you're here, maybe your skin has been asking for something your body hasn't had time to receive.</p>
              <p>Maybe you've tried every product, every treatment, every recommendation — and yet something still doesn't feel quite right.</p>
              <p>I know that feeling.</p>
              <p>Studio A wasn't created because I wanted another beauty studio. It was created because I needed somewhere that reminded me what <strong>slowing down</strong> actually felt like.</p>
              <p>For years, I understood beauty through makeup, skin and the outside image. But over time, I realised that the face often carries much more than texture, redness or tiredness.</p>
              <p>It carries stress.<br />It carries lack of sleep.<br />It carries tension.<br />It carries everything we keep moving through without stopping.</p>
              <p>Studio A is my way of creating a space where women can <strong>pause before they are treated</strong>. Where the <strong>skin is listened to</strong>. Where the <strong>nervous system is considered</strong>. Where nothing is rushed, and nothing needs to be performed.</p>
              <p>My work is not about changing your face. It is about helping you feel <strong>more connected to yourself</strong> inside the skin you already live in.</p>
              <p>If you arrive tired, overwhelmed, sensitive, emotional or unsure where to begin, you are welcome here.</p>
              <p>You don't need to know exactly what your skin needs before you come. We begin there together.</p>
              <p className="label-eyebrow mt-16">— Anissa</p>
            </div>
          </Reveal>

          <Reveal delay={0.2}>
            <div className="mt-20 text-center border-t border-[#D5CDBF] pt-16">
              <Link to="/book" data-testid="letter-book-btn" className="btn-primary inline-flex">
                Begin Your Ritual
              </Link>
            </div>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
